import React from "react";
import { AlertTriangle, XCircle } from "lucide-react";
import { useSubscription } from "@/hooks/useSubscription";
import { Link } from "react-router-dom";

/**
 * SubscriptionBanner — sticky banner untuk tenant admin.
 * Muncul kalau subscription EXPIRED atau SUSPENDED.
 */
export default function SubscriptionBanner() {
  const { subscription } = useSubscription();
  if (!subscription) return null;
  const status = subscription.status;
  if (status !== "EXPIRED" && status !== "SUSPENDED") return null;

  const isExpired = status === "EXPIRED";
  const bg = isExpired ? "bg-rose-50 border-rose-400" : "bg-amber-50 border-amber-400";
  const text = isExpired ? "text-rose-700" : "text-amber-700";
  const descText = isExpired ? "text-rose-900/80" : "text-amber-900/80";
  const ctaText = isExpired ? "text-rose-700 hover:text-rose-900" : "text-amber-700 hover:text-amber-900";
  const Icon = isExpired ? XCircle : AlertTriangle;
  const title = isExpired ? "Subscription Expired" : "Subscription Suspended";
  const desc = isExpired
    ? "Masa aktif subscription Anda telah berakhir. Silakan perbarui langganan untuk mengakses dashboard sepenuhnya."
    : `Subscription Anda sedang disuspend${
        subscription.subscription?.suspended_reason ? `: "${subscription.subscription.suspended_reason}"` : "."
      } Hubungi Platform untuk mengaktifkan kembali.`;

  return (
    <div className={`border-l-4 ${bg} px-4 py-3 flex items-center gap-3 rounded-r-xl mb-4`}
      data-testid={`subscription-banner-${status.toLowerCase()}`}>
      <Icon size={20} className={text + " shrink-0"} />
      <div className="min-w-0 flex-1">
        <div className={`font-black text-sm ${text}`}>{title}</div>
        <div className={`text-xs ${descText} mt-0.5`}>{desc}</div>
      </div>
      <Link to="/admin/langganan" className={`text-xs font-bold ${ctaText} underline whitespace-nowrap`}
        data-testid="subscription-banner-cta">
        Lihat Detail
      </Link>
    </div>
  );
}
